import { CurrencyDecimal } from '@lib/types/currency';

import { TypographyProps } from '@components/Typography';

export interface OrderLineItemProps extends TypographyProps {
    label: string;
    testID?: string;
    amount: CurrencyDecimal;
    color?: TypographyProps['color'];
    hideOnZero?: boolean;
    isTotal?: boolean;
}

export interface ContentProps {
    color?: OrderLineItemProps['color'];
    testID?: string;
    label: string;
    amount: string;
    isTotal?: boolean;
}

export const FormatOptions = {
    style: 'currency' as const,
    currency: 'usd'
};
